export function lightenDarkenColor(col, amt) {
  console.log(col)
  const num = parseInt(col.substring(1), 16)
  const r = (num >> 16) + amt
  const b = ((num >> 8) & 0x00ff) + amt
  const g = (num & 0x0000ff) + amt
  const newColor = g | (b << 8) | (r << 16)
  return '#' + newColor.toString(16)
}

export function formatHTML(description: string) {
  let sections = description.split('❖ ')
  let ret
  if (sections.length === 1) {
    sections = description.split('\\n')
    if (sections.length === 1) {
      return '<div>' + description + '</div>'
    }
  }
  ret = '<div style="margin-bottom: .25rem">' + sections[0] + '</div>'
  sections.shift()
  sections.forEach((s) => {
    ret +=
      '<li style="padding-left: 1rem; margin-bottom: .25rem;list-style-type:none;text-indent: -1rem ;">' +
      '❖ ' +
      s +
      '</li>'
  })

  return ret
}
export function getListFromArray(arr: string[]) {
  if (arr.length >= 0) return arr.reduce((acc, val) => acc + val + ', ', '').slice(0, -2)
  return ''
}
